import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme>(({ palette, spacing }) => {
  return {
    root: {
      color: "black",
      border: "none",
      "&.MuiDataGrid-autoHeight .MuiDataGrid-row--lastVisible .MuiDataGrid-cell":
        {
          borderBottomColor: palette.grey[100],
        },
      "& .MuiDataGrid-cell": {
        padding: spacing(3),
        alignItems: "start",
        "&:focus": {
          outline: "none",
        },
        "&:focus-within": {
          outline: "none",
        },
      },
      "& .MuiDataGrid-columnHeader": {
        padding: spacing(3),
        "&:focus": {
          outline: "none",
        },
        "&:focus-within": {
          outline: "none",
        },
        "&:last-of-type .MuiDataGrid-iconSeparator": {
          display: "none",
        },
      },
      "& .MuiDataGrid-row": {
        backgroundColor: palette.common.white,
        "&:hover": {
          backgroundColor: palette.common.white,
        },
      },
      "& .MuiDataGrid-footerContainer": {
        borderTopColor: "transparent",
      },
      "& .MuiDataGrid-columnSeparator": {
        visibility: "visible",
      },
    },
    hiddenHeaderSeparatorRoot: {
      "& .MuiDataGrid-columnSeparator--sideRight": {
        display: "none",
      },
    },
  };
});

export default useStyles;
